import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import {CustomSelect} from 'components/CustomSelect'
import AuthenticationService from "service/AuthenticationService";
import NumberFormat from 'react-number-format';
import { Col, Container, Form, Overlay, Row } from "react-bootstrap";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import useWindowDimensions from "hooks/Dimensions";
import * as URL from "service/UrlConstant";
import { SecurityContext } from "context/security";
import {
    formatDateStringToDatePickerFormat,
    getCurrentDate,
    getCurrentDateToDatePickerFormat,
    getMaxYear4DigitsFormat,
    yearMonthDayToPickerDateFormat
} from "utils/FormatUtils";
import { EntityAccountsContext } from "components/entity-accounts/context";
import { AssetTransferEntityAccountsPart } from "pages/wires/AssetTransferEntityAccountsPart";
import {
    ASSET_TRANSFER_CAPTURE_PANEL_ENTRY_RESULT
} from "./context/AssetTransferContext";
import { ToastContext } from "context/Toast";
import { useHistory } from "react-router-dom";
import * as Routes from "routes/Routes";
import UserRoleService, {
    ASSET_TRANSFER_SUBMITTER,ASSET_TRANSFER_INTERNAL_USER,ASSET_TRANSFER_VIEWONLY
} from "service/UserRoleService";
import {
    VALIDATION_IN_JS, GRID_COLUMN_PROPERTY,
    REGEX_ASSET_TRANSFER_ENTRY_WHOLE_NUMBER,
    REGEX_ASSET_TRANSFER_ENTRY_SECURITY_CODE,
    REGEX_ASSET_TRANSFER_ENTRY_DECIMAL_NUMBER,
    REGEX_ASSET_TRANSFER_ENTRY_CURRENCY
} from "utils/Constants";
import { formatAmount } from "../../utils/NumberUtils";
import { validateValueOnRegex } from "../../utils/RegexUtils";
import {
    ASSET_TRANSFER_ENTRY_COMMENTS_MSG,
    ASSET_TRANSFER_ENTRY_CURRENCY_MSG,
    ASSET_TRANSFER_ENTRY_DECIMAL_NUMBER_MSG,
    ASSET_TRANSFER_ENTRY_SECURITY_CODE_MSG,
    ASSET_TRANSFER_ENTRY_WHOLE_NUMBER_MSG,
} from "../../utils/ConstantsMsg";
import { getAllErrorValuesAsString } from "../../utils/ErrorUtils";
import { AssetTransferContext } from "./context";
import {useLocation} from "react-router";

const assetTransferTypeJSON = [
    { "id": "DTC", "name": "DTC" },
    { "id": "INTL", "name": "INTL" },
    { "id": "FED", "name": "FED" }
];
const instructionTypeList = ['DF', 'RF', 'DVP', 'RVP'];
const instructionTypeJSON = [
    {"id":"","name":"Select"},
    { "id": "DF", "name": "DF" },
    { "id": "RF", "name": "RF" },
    { "id": "DVP", "name": "DVP" },
    { "id": "RVP", "name": "RVP" },
];
const accountTypeList = ['1', '2', '5'];
const accountTypeJSON = [
    {"id":"","name":"Select"},
    { "id": "2", "name": "Long" },
    { "id": "5", "name": "Short" },
    { "id": "1", "name": "Cash" }
];

const dtcMandatoryFieldsMap = new Map([
    ["custRefNum", 1],
    ["accountType", 1],
    ["instructionType", 1],
    ["srcSecCd", 1],
    ["settleDate", 1],
    ["settleQuantity", 1],
    ["settleAmount", 1],
    ["dtcNumber", 1],
    ["dtcAcctNumber", 1]]
);
const intlMandatoryFieldsMap = new Map([
    ["custRefNum", 1],
    ["accountType", 1],
    ["instructionType", 1],
    ["srcSecCd", 1],
    ["tradeDate", 1],
    ["settleDate", 1],
    ["settleQuantity", 1],
    ["settleLocation", 1],
    ["settleCurrency", 1],
    ["settleAmount", 1],
    ["brokerMpidId", 1],
    ["cptyAccountNumber", 1]
]);
const fedMandatoryFieldsMap = new Map([
    ["custRefNum", 1],
    ["accountType", 1],
    ["instructionType", 1],
    ["srcSecCd", 1],
    ["settleDate", 1],
    ["settleQuantity", 1],
    ["settleLocation", 1],
    ["settleCurrency", 1],
    ["settleAmount", 1],
    ["fedInstruction", 1],
]);

export default function AssetTransferEntry() {

    const { assetTransferCaptureDisplayState, setAssetTransferCaptureDisplayState, clearAssetTransferSearchAndLoadHome, clearAssetTransferEntry, setAmendClicked } = useContext(AssetTransferContext);
    const { viewClicked, setViewClicked } = useContext(AssetTransferContext);
    const [disableSubmit, setDisableSubmit] = useState(false);
    const [rowData, setRowData] = useState([]);
    const [errors, setErrors] = useState({});
    const [isDisabled, setIsDisabled] = useState(false);
    const { entityAccountsNoSwap, showAccounts, setShowAccounts, validateEntityAccountSearch, clearEntityAccounts, accountsOptionsNoSwap, setManagerDetailsWithOptionalAccount, entityAccountsOptionsNoSwap, populateDefaultEntity } = useContext(EntityAccountsContext);
    const { makePostRequest, makePostRequestWithParams, makeGetRequest, makeGetRequestNoParams } = useContext(SecurityContext)
    const { success, error } = useContext(ToastContext);
    const { isMobile } = useWindowDimensions();
    let history = useHistory();
    const [currencies, setCurrencies] = useState([]);
    const [countries, setCountries] = useState([]);
    const [mpids, setMpids] = useState([])

    const [mandatoryFieldsMap, setMandatoryFieldsMap] = useState(new Map());
    // const[custRefNumS, setCustRefNumS] = useState('');
    const [accountTypeS, setAccountTypeS] = useState('');
    const [instructionTypeS, setInstructionTypeS] = useState('');
    const [brokerMpidIdS, setBrokerMpidIdS] = useState('');
    const [cptyAccountNumberS, setCptyAccountNumberS] = useState('');
    const [srcSecCdS, setSrcSecCdS] = useState('');
    const [tradeDateS, setTradeDateS] = useState('');
    const [settleDateS, setSettleDateS] = useState('');
    const [settleLocationS, setSettleLocationS] = useState('');
    const [settleCurrencyS, setSettleCurrencyS] = useState('');
    const [settleQuantityS, setSettleQuantityS] = useState('');
    const [settleAmountS, setSettleAmountS] = useState('');
    const [dtcNumberS, setDtcNumberS] = useState('');
    const [dtcAcctNumberS, setDtcAcctNumberS] = useState('');
    const [fedInstructionS, setFedInstructionS] = useState('');
    const [additionalInfoS, setAdditionalInfoS] = useState('');
    const [commentsS, setCommentsS] = useState('');

    const [settleReadOnly, setSettleReadOnly] = useState(false)
    const [dtcNumberReadOnly, setDtcNumberReadOnly] =  useState(false)
    const [dtcAcctNumberReadOnly, setDtcAcctNumberReadOnly] =  useState(false)
    const [fedInstructionReadOnly, setFedInstructionReadOnly] =  useState(false)
    const [brokerMpidIdReadOnly, setBrokerMpidIdReadOnly] =  useState(false)
    const [cptyAccountNumberReadOnly, setCptyAccountNumberReadOnly] =  useState(false)
	const [assetTransferSubmitter, setAssetTransferSubmitter] = useState(false)
    const [settleAmountDisabled, setSettleAmountDisabled] = useState(false)

    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const fromVar = params.get('from');
    const fromMenu = (fromVar && fromVar === 'menu')? true : false;

    const target = useRef(null);
    const assetTransferDateLabelRef = useRef(null);
    const settleDateLabelRef = useRef(null);
    const settleAmountLabelRef = useRef(null);
    const quantityLabelRef = useRef(null);
    let id = assetTransferCaptureDisplayState.assetTransferEntry.uiStatus;

    const checkPermission = (menuKey) => {
        return UserRoleService.hasPermission(menuKey);
    }

    function navigateToPage(path) {
        history.push(path);
    }

    function getMandatoryStar(field) {
        return mandatoryFieldsMap.has(field) ? true:false;
    }
    function getMandatoryStarOnSettleAmount() {
        let required = getMandatoryStar('settleAmount')
        if (required) {
             if (assetTransferCaptureDisplayState.assetTransferEntry.instructionType === 'DF' || assetTransferCaptureDisplayState.assetTransferEntry.instructionType === 'RF'){
                   // settle amount is not required
                   return false
             } else {
                   return true
             }
        } else {
            return false
        }
    }

    function processMandatoryStar() {
        // setCustRefNumS(getMandatoryStar("custRefNum"))
        setAccountTypeS(getMandatoryStar("accountType"))
        setInstructionTypeS(getMandatoryStar("instructionType"))
        setBrokerMpidIdS(getMandatoryStar("brokerMpidId"))
        setCptyAccountNumberS(getMandatoryStar("cptyAccountNumber"))
        setSrcSecCdS(getMandatoryStar("srcSecCd"))
        setTradeDateS(getMandatoryStar("tradeDate"))
        setSettleDateS(getMandatoryStar("settleDate"))
        setSettleLocationS(getMandatoryStar("settleLocation"))
        setSettleCurrencyS(getMandatoryStar("settleCurrency"))
        setSettleQuantityS(getMandatoryStar("settleQuantity"))
        setDtcNumberS(getMandatoryStar("dtcNumber"))
        setDtcAcctNumberS(getMandatoryStar("dtcAcctNumber"))
        setFedInstructionS(getMandatoryStar("fedInstruction"))
    }

    useEffect(() => {
        // process on data from view clicked
        if ( viewClicked) {
            let assetTransferCaptureDisplayStateChange = { ...assetTransferCaptureDisplayState };

            // check if instruction type is DF or RF, then check if settleAmount is zero, set settleAmountDisabled to true
            if (assetTransferCaptureDisplayState.assetTransferEntry.instructionType === 'DF' || assetTransferCaptureDisplayState.assetTransferEntry.instructionType === 'RF') {
                let currentSettleAmount = assetTransferCaptureDisplayState.assetTransferEntry.settleAmount ? assetTransferCaptureDisplayState.assetTransferEntry.settleAmount.toString().replaceAll(",", "") : '0.00'
                if (settleAmountRequireCheck(currentSettleAmount)){
                    setSettleAmountDisabled(true)
                }
            }

            // check if settleLocation is '', set to US as default
            if (assetTransferCaptureDisplayState.assetTransferEntry.settleLocation === '' || assetTransferCaptureDisplayState.assetTransferEntry.settleLocation === null) {
                assetTransferCaptureDisplayStateChange['assetTransferEntry']['settleLocation'] = 'US';
                setAssetTransferCaptureDisplayState(assetTransferCaptureDisplayStateChange);
            }
        }
    }, [])


    useEffect(() => {
        populateDefaultEntity(true,true)
    }, [entityAccountsOptionsNoSwap])

	useEffect(() => {
	        // if account code is in assetTransferSumitterList, value is true
            let submitter = true
            if (entityAccountsNoSwap.accountCode){
			    submitter = AuthenticationService.isAssetTransferSubmitterOnAccountCode( entityAccountsNoSwap.accountCode)
            }
            setAssetTransferSubmitter(submitter)
			
			const userAssetTransferSubmitter = checkPermission(ASSET_TRANSFER_SUBMITTER)
			const userAssetTransferInternalUser = checkPermission(ASSET_TRANSFER_INTERNAL_USER)
			if (submitter && (userAssetTransferSubmitter || userAssetTransferInternalUser)){
				setDisableSubmit(false)
			} else {
				setDisableSubmit(true)
			}
	    }, [entityAccountsNoSwap.accountCode])
	
	
    // useEffect(() => {
    //     if (assetTransferCaptureDisplayState.assetTransferEntry.managerId == null || assetTransferCaptureDisplayState.assetTransferEntry.managerId == "") {
    //         return;
    //     }

    //     let managerInfo = entityAccountsOptions.filter(item => item.managerId === assetTransferCaptureDisplayState.assetTransferEntry.managerId);
    //     let managerName = '';
    //     if (managerInfo && managerInfo.length > 0) {
    //         managerName = managerInfo[0].shortName + '-' + managerInfo[0].longName;
    //     }
    //     setManagerDetailsWithOptionalAccount(assetTransferCaptureDisplayState.assetTransferEntry.managerId, managerName, false);
    // }, [assetTransferCaptureDisplayState.assetTransferEntry.managerId, viewClicked])

    useEffect(() => {
        let accountsOptionList = accountsOptionsNoSwap

        if (assetTransferCaptureDisplayState.assetTransferEntry.accountId && assetTransferCaptureDisplayState.assetTransferEntry.accountId != "") {
            accountsOptionList = accountsOptionsNoSwap.filter(item => item.accountId === assetTransferCaptureDisplayState.assetTransferEntry.accountId)
        }

    }, [accountsOptionsNoSwap, viewClicked])

    useEffect(() => {
        getCurrencies()
        getIsoCountryCode()
    }, [])
    useEffect(() => {
        if (!viewClicked || fromMenu) {
            initAssetTransferEntryPage()
            clearEntityAccounts(undefined,undefined,true);
            id = ''
        }
    }, [])

    useEffect(() => {
        setMpids([])
        getMpids()
    }, [entityAccountsNoSwap.managerId])


    const initAssetTransferEntryPage = () => {
        // init create asset transfer entry
        clearAssetTransferEntry()
        let assetTransferCaptureDisplayStateChange = { ...assetTransferCaptureDisplayState };
        assetTransferCaptureDisplayStateChange['assetTransferEntry']['category'] = 'DTC';
        assetTransferCaptureDisplayStateChange['assetTransferEntry']['accountType'] = '';
        assetTransferCaptureDisplayStateChange['assetTransferEntry']['instructionType'] = '';
        assetTransferCaptureDisplayStateChange['assetTransferEntry']['settleLocation'] = 'US';
        assetTransferCaptureDisplayStateChange['assetTransferEntry']['settleCurrency'] = 'USD';
        setAssetTransferCaptureDisplayState(assetTransferCaptureDisplayStateChange);
    }


    useEffect(() => {
        if (currencies && currencies.length > 0) {
            if (assetTransferCaptureDisplayState['assetTransferEntry']['settleCurrency']) {
                // keep the current currency code
            } else {
                let assetTransferCaptureDisplayStateChange = { ...assetTransferCaptureDisplayState };
                setAssetTransferCaptureDisplayState(assetTransferCaptureDisplayStateChange);
            }
        }
    }, [currencies])
    useEffect(() => {
        if (countries && countries.length > 0) {
            if (assetTransferCaptureDisplayState['assetTransferEntry']['settleCountry']) {
                // keep the current country code
            }
            else {
                let assetTransferCaptureDisplayStateChange = { ...assetTransferCaptureDisplayState };
                setAssetTransferCaptureDisplayState(assetTransferCaptureDisplayStateChange);
            }
        }
    }, [countries])

    useEffect(() => {
        let assetTransferCaptureDisplayStateChange = { ...assetTransferCaptureDisplayState };
        if (!viewClicked || fromMenu) {
             assetTransferCaptureDisplayState['assetTransferEntry']['brokerMpidId'] = ''
        }
        setAssetTransferCaptureDisplayState(assetTransferCaptureDisplayStateChange);
    }, [mpids])


    useEffect(() => {
        handleSecurityOnBlur()
    }, [id])

    useEffect(() => {
        if (assetTransferCaptureDisplayState.assetTransferEntry.category) {
            if (assetTransferCaptureDisplayState.assetTransferEntry.category === "DTC") {
                setMandatoryFieldsMap(dtcMandatoryFieldsMap)
                // settleLocation   US,  settleCurrency USD,  readonly
                setDefaultSettleLocationCurrency('US', 'USD', true)
            } else if (assetTransferCaptureDisplayState.assetTransferEntry.category === "INTL") {
                setMandatoryFieldsMap(intlMandatoryFieldsMap)
                if (!viewClicked || fromMenu) {
                    // settleLocation default is EU, settleCurrency is EUR
                    setDefaultSettleLocationCurrency('EU', 'EUR', false)
                }
            } else if (assetTransferCaptureDisplayState.assetTransferEntry.category === "FED") {
                setMandatoryFieldsMap(fedMandatoryFieldsMap)
                // settleLocation   US,  settleCurrency USD,  readonly
                setDefaultSettleLocationCurrency('US', 'USD', true)
            } else {
                setMandatoryFieldsMap(new Map())
            }
        }

        setAssetTransferEntryOtherValuesOnCategory(assetTransferCaptureDisplayState.assetTransferEntry.category)
        setErrors([])

    }, [assetTransferCaptureDisplayState.assetTransferEntry.category])

    useEffect(() => {
        // handle required field stars
        processMandatoryStar()
    }, [mandatoryFieldsMap])

    useEffect(() => {
        // handle required field stars on settle amount
        setSettleAmountS(getMandatoryStarOnSettleAmount())
    }, [mandatoryFieldsMap,assetTransferCaptureDisplayState.assetTransferEntry.instructionType ])

    const setDefaultSettleLocationCurrency = (settlementLocation, settlementCurrency, settlementReadOnly) => {
        let assetTransferCaptureDisplayStateChange = { ...assetTransferCaptureDisplayState };
        assetTransferCaptureDisplayState['assetTransferEntry']['settleLocation'] = settlementLocation
        assetTransferCaptureDisplayState['assetTransferEntry']['settleCurrency'] = settlementCurrency
        setSettleReadOnly(settlementReadOnly)
        setAssetTransferCaptureDisplayState(assetTransferCaptureDisplayStateChange);
    }



    useEffect(() => {
        setIsDisabled(handleFormDisable)
    }, [id, assetTransferCaptureDisplayState.assetTransferEntry.status, assetTransferCaptureDisplayState.assetTransferEntry.dbSource, assetTransferCaptureDisplayState.assetTransferEntry.indTradeCancel])

    const handleFormDisable = () => {
        return (id && assetTransferCaptureDisplayState.assetTransferEntry.indAssetTransferCancel)
    }

    const handleSecurityOnBlur = (e) => {
        if (assetTransferCaptureDisplayState.assetTransferEntry.srcSecCd) {
            searchSecurity();
        }
    }

    const getCurrencies = () => {
        const onSuccessResponse = (res) => {
            if (res.data) {
                setCurrencies(res.data);
            }
        }

        const onErrorResponse = () => {}

        makeGetRequestNoParams(URL.CURRENCY_LIST_UNIQUE_URL, onSuccessResponse, onErrorResponse)
    }
    const getIsoCountryCode = () => {
        const onSuccessResponse = (res) => {
            if (res.data) {
                setCountries(res.data);
            }
        }

        const onErrorResponse = () => {}

        makeGetRequestNoParams(URL.COUNTRY_LIST_UNIQUE_URL, onSuccessResponse, onErrorResponse)
    }

    const getMpids = () => {
        const onSuccessResponse = (res) => {
            if (res.data) {
                setMpids(res.data);
            }
        }

        const onErrorResponse = () => {}
        
        if (entityAccountsNoSwap.managerId) {
            makePostRequest({
                managerId: entityAccountsNoSwap.managerId
            },
            URL.BROKER_MPIDS_BY_MANAGER_URL, onSuccessResponse, onErrorResponse);
        }
    }


    const searchSecurity = () => {
        const securityCode = getSecurity()

        const params = {
            "securityCode": securityCode
        }

        const onSuccessResponse = (res) => {
            if (res.data) {
                let assetTransferCaptureDisplayStateChange = { ...assetTransferCaptureDisplayState };
                assetTransferCaptureDisplayStateChange['assetTransferEntry']['securityDescription'] =
                    res.data[0] && res.data[0]['longName'] != null ? res.data[0]['longName'] : ''
                if (res.data[0] && res.data[0]['longName'] != null) {
                    assetTransferCaptureDisplayStateChange['assetTransferEntry']['srcSecCd'] = securityCode ? securityCode.toUpperCase() : '';
                } else {
                    let errs = {}
                    errs['srcSecCd'] = "Security Id is invalid"
                    setErrors(errs)
                }

                setAssetTransferCaptureDisplayState(assetTransferCaptureDisplayStateChange);
            }
        }

        const onErrorResponse = (err) => {
            error("Error getting security description")
            console.error("Error on search security: ", err);
        }

        makeGetRequest(URL.SECURITY_SEARCH_URL, params, onSuccessResponse, onErrorResponse)
    }

    const getSecurity = () => {
        let security = '';
        if (assetTransferCaptureDisplayState.assetTransferEntry.srcSecCd) {
            security = assetTransferCaptureDisplayState.assetTransferEntry.srcSecCd;
        }
        return security.trim();
    }

    const handleOnChangeNumber = ({ formattedValue, value, floatValue }, name) => {
        const field = name;
        let assetTransferCaptureDisplayStateChange = { ...assetTransferCaptureDisplayState };
        assetTransferCaptureDisplayStateChange['assetTransferEntry'][field] = formattedValue
        setAssetTransferCaptureDisplayState(assetTransferCaptureDisplayStateChange);
        clearErrors(field)
    }

    const handleOnChange = (e) => {
        const field = e.currentTarget.name;
        const value = e.currentTarget.value;
        const { type, checked } = e.target;

        let assetTransferCaptureDisplayStateChange = { ...assetTransferCaptureDisplayState };
        assetTransferCaptureDisplayStateChange['assetTransferEntry'][field] = value

        if (field && field === 'instructionType') {
            if (value === 'DF' || value === 'RF') {
                assetTransferCaptureDisplayStateChange['assetTransferEntry']['settleAmount'] = 0.00;
                setSettleAmountDisabled(true)
                // remove error on related fields
                clearErrors('settleAmount')
            } else {
                setSettleAmountDisabled(false)
            }
        }

        setAssetTransferCaptureDisplayState(assetTransferCaptureDisplayStateChange);
        clearErrors(field)
    }

    const handleTradeDateBlur = (e) => {
        if (e.currentTarget.value === null || e.currentTarget.value.length === 0) {
            setAssetTransferCaptureDisplayState(prevAssetTransferCaptureDisplayState => ({
                ...prevAssetTransferCaptureDisplayState, assetTransferEntry: {
                    ...prevAssetTransferCaptureDisplayState.assetTransferEntry, tradeDate: getCurrentDateToDatePickerFormat()
                }
            }));
        }
    }

    const clearErrors = (field) => {
        if (!!errors[field]) {
            delete errors[field]
            setErrors(errors);
        }
    }

    useEffect(() => {
        if (rowData.length === 1) {
            const quantity = formatAmount(assetTransferCaptureDisplayState.assetTransferEntry.quantity)
            const commission = formatAmount(assetTransferCaptureDisplayState.assetTransferEntry.commission)
            const accruedInterest = formatAmount(assetTransferCaptureDisplayState.assetTransferEntry.accruedInterest)

            const updatedRowData = rowData.map((row) => {
                return { ...row, allocation: quantity, commission: commission, accruedInterest: accruedInterest, };
            });
            setRowData(updatedRowData);
        }
    }, [assetTransferCaptureDisplayState.assetTransferEntry.quantity, assetTransferCaptureDisplayState.assetTransferEntry.commission, assetTransferCaptureDisplayState.assetTransferEntry.accruedInterest]);
    const settleQuantityRequireCheck = (settleQuantity) => {
        if (settleQuantity === null || settleQuantity.length <= 0 || settleQuantity === "0" || (settleQuantity != null && typeof settleQuantity === "string" && parseFloat(settleQuantity) <= 0.00) || (settleQuantity != null && typeof settleQuantity === "number" && settleQuantity <= 0.00))
            return true
        else
            return false
    }
    const settleAmountRequireCheck = (settleAmount) => {
        if (settleAmount === null || settleAmount.length <= 0 || (settleAmount != null && typeof settleAmount === "string" && parseFloat(settleAmount) <= 0.00) || (settleAmount != null && typeof settleAmount === "number" && settleAmount <= 0.00))
            return true
        else
            return false
    }
    const validateForm = (formData) => {
        let errors = {};

        errors = validateEntityAccountSearch(true,true)
        if (!formData.category) {
            errors['category'] = "Asset Transfer Type is required";
        } else {
            if (!(formData.category === "DTC" || formData.category === "INTL" || formData.category === "FED")) {
                errors['category'] = "Asset Transfer Type must be in DTC,INTL,FED";
            }
        }

        // if (mandatoryFieldsMap.has("custRefNum")) {
        //  if (formData.custRefNum === null || formData.custRefNum.length <= 0)
        //      errors['accounts'] = "Account Number is Required"
        // }

        if (mandatoryFieldsMap.has("instructionType")) {
            if (!formData.instructionType) {
                errors['instructionType'] = "Instruction Type is required";
            } else {
                if (!(formData.instructionType === "DF" || formData.instructionType === "RF" || formData.instructionType === "DVP" || formData.instructionType === "RVP")) {
                    errors['instructionType'] = "Instruction Type must be in DF,RF,DVP,RVP";
                }
            }
        }

        if (mandatoryFieldsMap.has("brokerMpidId")) {
            if (formData.brokerMpidId === null || formData.brokerMpidId.length <= 0)
                errors['brokerMpidId'] = "Broker MPID is Required"
        }

        if (mandatoryFieldsMap.has("cptyAccountNumber")) {
         if (formData.cptyAccountNumber === null || formData.cptyAccountNumber.length <= 0)
             errors['cptyAccountNumber'] = "CPTY Account is Required"
        }

        if (mandatoryFieldsMap.has("accountType")) {
            if (!formData.accountType) {
                errors['accountType'] = "Long/Short/Cash is required";
            } else {
                // check accountType is 1, 2, 5
                if (!(formData.accountType === "1"  || formData.accountType === "2" || formData.accountType === "5")) {
                    errors['accountType'] = "Long/Short/Cash account type must be 1, 2 or 5";
                }
            }
        }
        if (mandatoryFieldsMap.has("srcSecCd")) {
            if (formData.srcSecCd === null || formData.srcSecCd.length <= 0)
                errors['srcSecCd'] = "Security Id is Required"
        }

        let currentDate = new Date()
        let currentDateStr = (formatDateStringToDatePickerFormat(currentDate)).replaceAll("-", "")
        if (mandatoryFieldsMap.has("tradeDate")) {
            if (formData.tradeDate === null || formData.tradeDate.length <= 0) {
                errors['tradeDate'] = "Trade Date is Required"
            }
        }
        if (formData.tradeDate !== null && formData.tradeDate.length > 0 && formData.tradeDate !== currentDateStr) {
            errors['tradeDate'] = "Trade Date must be today's date"
        }

        if (mandatoryFieldsMap.has("settleDate")) {
            if (formData.settleDate === null || formData.settleDate.length <= 0) {
                errors['settleDate'] = "Settlement Date is Required"
            }
        }
        if (formData.settleDate != null && formData.settleDate.length > 0 && formData.settleDate < currentDateStr) {
            errors['settleDate'] = "Settlement Date cannot be back dated"
        }


        if (mandatoryFieldsMap.has("settleLocation")) {
            if (formData.settleLocation === null || formData.settleLocation.length <= 0){
                errors['settleLocation'] = "Settle Location is Required"
            }
            // DTC, FED   settleLocation is USformData.category
            if (formData.category && ( formData.category === 'DTC' || formData.category === 'FED')) {
                 if (!(formData.settleLocation  && formData.settleLocation === 'US')) {
                    errors['settleLocation'] = "Settle Location must be US with Asset Transfer Type " + formData.category
                 }
            }
        }
        if (mandatoryFieldsMap.has("settleCurrency")) {
            if (formData.settleCurrency === null || formData.settleCurrency.length <= 0){
                errors['settleCurrency'] = "Settle Currency is Required"
            }
            // DTC, FED   settleLocation is USformData.category
            if (formData.category && ( formData.category === 'DTC' || formData.category === 'FED')) {
                if (!(formData.settleCurrency  && formData.settleCurrency === 'USD')) {
                    errors['settleCurrency'] = "Settle Currency must be USD with Asset Transfer Type " + formData.category
                }
            }
        }
        if (mandatoryFieldsMap.has("settleQuantity")) {
            if (settleQuantityRequireCheck(formData.settleQuantity))
                errors['settleQuantity'] = "Settle Quantity is Required"
        }
        if (mandatoryFieldsMap.has("settleAmount")) {
            if (formData.instructionType){
                if (!(formData.instructionType==='DF' || formData.instructionType==='RF')){
                    if (settleAmountRequireCheck(formData.settleAmount)){
                        errors['settleAmount'] = "Settle Amount is Required"
                    }
                } else {
                    // settleAmount must be zero
                    if (!settleAmountRequireCheck(formData.settleAmount)){
                        errors['settleAmount'] = "Settlement Amount must be zero on instruction type DF/RF"
                    }
                }
            } else {
                errors['settleAmount'] = "Settle Amount is Required"
            }
        }
        if (mandatoryFieldsMap.has("dtcNumber")) {
            if (formData.dtcNumber === null || formData.dtcNumber.length <= 0)
                errors['dtcNumber'] = "DTC Number is Required"
        }
        if (mandatoryFieldsMap.has("dtcAcctNumber")) {
            if (formData.dtcAcctNumber === null || formData.dtcAcctNumber.length <= 0)
                errors['dtcAcctNumber'] = "DTC Account Number is Required"
        }
        if (mandatoryFieldsMap.has("fedInstruction")) {
            if (formData.fedInstruction === null || formData.fedInstruction.length <= 0)
                errors['fedInstruction'] = "FED Delivery Instruction is Required"
            if (formData.fedInstruction  &&  formData.fedInstruction.length > 100)
                errors['fedInstruction'] = "FED Delivery Instruction max length is 100"
        }
        if (mandatoryFieldsMap.has("additionalInfo")) {
            if (formData.additionalInfo === null || formData.additionalInfo.length <= 0)
                errors['additionalInfo'] = "Additional Information is Required"
        }
        let errorsRegex = validateTradeEntryRegex(formData.settleQuantity, formData.srcSecCd, formData.settleAmount, formData.settleCurrency, formData.comment)
        if (errorsRegex) {
            errors = { ...errors, ...errorsRegex }
        }
        return errors
    }

    const validateTradeEntryRegex = (settleQuantity, srcSecCd, settleAmount, settleCurrency, comment) => {
        let errors = {}
        let match = false
        // settleQuantity
        if (settleQuantity && settleQuantity.length > 0) {
            match = validateValueOnRegex(settleQuantity, REGEX_ASSET_TRANSFER_ENTRY_WHOLE_NUMBER)
            if (!match) {
                errors['settleQuantity'] = ASSET_TRANSFER_ENTRY_WHOLE_NUMBER_MSG
            }
        }
        // security
        if (srcSecCd && srcSecCd.length > 0) {
            match = validateValueOnRegex(srcSecCd, REGEX_ASSET_TRANSFER_ENTRY_SECURITY_CODE)
            if (!match) {
                errors['srcSecCd'] = ASSET_TRANSFER_ENTRY_SECURITY_CODE_MSG
            }
        }


        // settleAmount
        if (settleAmount && settleAmount.length > 0) {
            match = validateValueOnRegex(settleAmount, REGEX_ASSET_TRANSFER_ENTRY_DECIMAL_NUMBER)
            if (!match) {
                errors['settleAmount'] = ASSET_TRANSFER_ENTRY_DECIMAL_NUMBER_MSG
            }
        }

        // settleCurrency
        if (settleCurrency && settleCurrency.length > 0) {
            match = validateValueOnRegex(settleCurrency, REGEX_ASSET_TRANSFER_ENTRY_CURRENCY)
            if (settleCurrency !== null && settleCurrency === "999") {
                match = true
            }
            if (!match) {
                errors['settleCurrency'] = ASSET_TRANSFER_ENTRY_CURRENCY_MSG
            }
        }

        return errors;
    }

    const validateCancelForm = (formData) => {
        let errors = {};
        errors = validateEntityAccountSearch(true,true)
        if (formData[0].requestId === null || formData[0].requestId.length <= 0)
            errors['requestId'] = "Request Id is Required"
        if (formData[0].manager === null || formData[0].manager.length <= 0)
            errors['manager'] = "Manager is Required"
        // if (formData.cdAccount === null || formData.cdAccount.length <= 0)
        //         errors['account'] = "Account Number is Required"
        return errors
    }
    const validateAmendForm = (formData) => {
        let errors = {}
        errors = validateForm(formData)
        if (formData.id === null || formData.manager.id <= 0) {
            errors['id'] = "Id is Required"
            error("Id is Required")
        }

        return errors
    }

    const handleOnClear = (e) => {
        e.preventDefault()
        clearAssetTransferSearchAndLoadHome()
        clearEntityAccounts(undefined, undefined, true)
        setErrors({})
        clearAssetTransferEntry();
        setViewClicked(false)
        initAssetTransferEntryPage()
    }
    const handleSubmit = (e) => {
        e.preventDefault()
        let formErrors = {}

        let managerNameUsed = ""
        if (assetTransferCaptureDisplayState.assetTransferEntry.manager) {
            managerNameUsed = assetTransferCaptureDisplayState.assetTransferEntry.manager
        } else {
            // new, need get from entityAccounts select component
            managerNameUsed = (entityAccountsNoSwap.managerName != null && entityAccountsNoSwap.managerName.indexOf("-") >= 0) ? entityAccountsNoSwap.managerName.substring(0, entityAccountsNoSwap.managerName.indexOf("-")) : entityAccountsNoSwap.managerName
        }
        let params = {
            "custRefNum": entityAccountsNoSwap.accountCode, //assetTransferCaptureDisplayState.assetTransferEntry.custRefNum,
            "category": assetTransferCaptureDisplayState.assetTransferEntry.category,
            "instructionType": assetTransferCaptureDisplayState.assetTransferEntry.instructionType,
            "accountType": assetTransferCaptureDisplayState.assetTransferEntry.accountType,
            "srcSecCd": assetTransferCaptureDisplayState.assetTransferEntry.srcSecCd,
            "tradeDate": assetTransferCaptureDisplayState.assetTransferEntry.tradeDate ? assetTransferCaptureDisplayState.assetTransferEntry.tradeDate.replaceAll("-", "") : assetTransferCaptureDisplayState.assetTransferEntry.tradeDate,
            "settleDate": assetTransferCaptureDisplayState.assetTransferEntry.settleDate ? assetTransferCaptureDisplayState.assetTransferEntry.settleDate.replaceAll("-", "") : assetTransferCaptureDisplayState.assetTransferEntry.settleDate,
            "settleLocation": assetTransferCaptureDisplayState.assetTransferEntry.settleLocation,
            "settleCurrency": assetTransferCaptureDisplayState.assetTransferEntry.settleCurrency,
            "settleQuantity": assetTransferCaptureDisplayState.assetTransferEntry.settleQuantity ? assetTransferCaptureDisplayState.assetTransferEntry.settleQuantity.replaceAll(",", "") : assetTransferCaptureDisplayState.assetTransferEntry.settleQuantity,
            "settleAmount": assetTransferCaptureDisplayState.assetTransferEntry.settleAmount ? assetTransferCaptureDisplayState.assetTransferEntry.settleAmount.toString().replaceAll(",", "") : '0.00',
            "additionalInfo": assetTransferCaptureDisplayState.assetTransferEntry.additionalInfo,
            "comment": '',
            "manager": managerNameUsed
        }

        params = addParamsOnCategory(assetTransferCaptureDisplayState, params)

        if (VALIDATION_IN_JS) {
            formErrors = validateForm(params);
        }
        if (Object.keys(formErrors).length > 0) {
            setErrors(formErrors)
            return
        }
        else {

            const onSuccessResponse = (res) => {
                if (res.data) {
                    let assetTransferCaptureDisplayStateChange = { ...assetTransferCaptureDisplayState }
                    assetTransferCaptureDisplayStateChange['assetTransferEntry']['resData'] = res.data
                    if (res?.data?.requestId) {
                        assetTransferCaptureDisplayStateChange['assetTransferEntry']['requestId'] = res.data.requestId
                    }
                    if (res?.data?.status) {
                        assetTransferCaptureDisplayStateChange['assetTransferEntry']['status'] = res.data.status
                    }
                    
                    assetTransferCaptureDisplayStateChange.currentPage = ASSET_TRANSFER_CAPTURE_PANEL_ENTRY_RESULT
                    setAssetTransferCaptureDisplayState(assetTransferCaptureDisplayStateChange);
                }
            }

            const onErrorResponse = (err) => {
                let errorMsg = getAllErrorValuesAsString(err.response.data)
                console.error("Error on creating new Asset Transfer:", errorMsg)
                error("Error on creating new Asset Transfer")
            }

            makePostRequest(params, URL.ASSET_TRANSFER_PROCESS_URL, onSuccessResponse, onErrorResponse)
        }
    }


    const handleBack = () => {
        let from = assetTransferCaptureDisplayState.assetTransferEntry.from
        setViewClicked(false)
		if (from && from === 'LIST') {
            clearEntityAccounts(undefined, undefined, true);
            clearAssetTransferEntry();
			navigateToPage(Routes.ASSET_TRANSFER_LIST)
		} else {
			let assetTransferCaptureDisplayStateChange = { ...assetTransferCaptureDisplayState }
			assetTransferCaptureDisplayStateChange.currentPage = ASSET_TRANSFER_CAPTURE_PANEL_ENTRY_RESULT
		    setAssetTransferCaptureDisplayState(assetTransferCaptureDisplayStateChange);
		}
    }

    const addParamsOnCategory = (assetTransferCaptureDisplayState, params) => {
        if (assetTransferCaptureDisplayState.assetTransferEntry.category && assetTransferCaptureDisplayState.assetTransferEntry.category === 'DTC') {
            params = {
                ...params,
                "dtcNumber": assetTransferCaptureDisplayState.assetTransferEntry.dtcNumber,
                "dtcAcctNumber": assetTransferCaptureDisplayState.assetTransferEntry.dtcAcctNumber
            }
        } else if (assetTransferCaptureDisplayState.assetTransferEntry.category && assetTransferCaptureDisplayState.assetTransferEntry.category === 'FED') {
            params = {
                ...params,
                "fedInstruction": assetTransferCaptureDisplayState.assetTransferEntry.fedInstruction,
            }
        } else if (assetTransferCaptureDisplayState.assetTransferEntry.category && assetTransferCaptureDisplayState.assetTransferEntry.category === 'INTL') {
            params = {
                ...params,
                "brokerMpidId": assetTransferCaptureDisplayState.assetTransferEntry.brokerMpidId,
                "cptyAccountNumber": assetTransferCaptureDisplayState.assetTransferEntry.cptyAccountNumber,
            }
        }
        return params
    }


    
    const setAssetTransferEntryOtherValuesOnCategory = (category) => {
        let assetTransferCaptureDisplayStateChange = { ...assetTransferCaptureDisplayState };
        
        if (category && category === 'DTC') {
            assetTransferCaptureDisplayStateChange['assetTransferEntry']['fedInstruction'] = '';
            assetTransferCaptureDisplayStateChange['assetTransferEntry']['brokerMpidId'] = '';
            assetTransferCaptureDisplayStateChange['assetTransferEntry']['cptyAccountNumber'] = '';
            setDtcNumberReadOnly(false)
            setDtcAcctNumberReadOnly(false)
            setFedInstructionReadOnly(true)
            setBrokerMpidIdReadOnly(true)
            setCptyAccountNumberReadOnly(true)
        } else if (category && category === 'FED') {
            assetTransferCaptureDisplayStateChange['assetTransferEntry']['dtcNumber'] = '';
            assetTransferCaptureDisplayStateChange['assetTransferEntry']['dtcAcctNumber'] = '';
            assetTransferCaptureDisplayStateChange['assetTransferEntry']['brokerMpidId'] = '';
            assetTransferCaptureDisplayStateChange['assetTransferEntry']['cptyAccountNumber'] = '';
            setDtcNumberReadOnly(true)
            setDtcAcctNumberReadOnly(true)
            setFedInstructionReadOnly(false)
            setBrokerMpidIdReadOnly(true)
            setCptyAccountNumberReadOnly(true)
        } else if (category && category === 'INTL') {
            assetTransferCaptureDisplayStateChange['assetTransferEntry']['dtcNumber'] = '';
            assetTransferCaptureDisplayStateChange['assetTransferEntry']['dtcAcctNumber'] = '';
            assetTransferCaptureDisplayStateChange['assetTransferEntry']['fedInstruction'] = '';
            setDtcNumberReadOnly(true)
            setDtcAcctNumberReadOnly(true)
            setFedInstructionReadOnly(true)
            setBrokerMpidIdReadOnly(false)
            setCptyAccountNumberReadOnly(false)
        }
        setAssetTransferCaptureDisplayState(assetTransferCaptureDisplayStateChange);
    }

    const handleAmend = (e) => {
        e.preventDefault()
        let formErrors = {}

        let managerNameUsed = ""
        if (assetTransferCaptureDisplayState.assetTransferEntry.manager) {
            managerNameUsed = assetTransferCaptureDisplayState.assetTransferEntry.manager
        } else {
            // new, need get from entityAccounts select component
            managerNameUsed = (entityAccountsNoSwap.managerName != null && entityAccountsNoSwap.managerName.indexOf("-") >= 0) ? entityAccountsNoSwap.managerName.substring(0, entityAccountsNoSwap.managerName.indexOf("-")) : entityAccountsNoSwap.managerName
        }
        let params =
        {
            "id": assetTransferCaptureDisplayState.assetTransferEntry.id,
            "requestId": assetTransferCaptureDisplayState.assetTransferEntry.requestId,
            "custRefNum": entityAccountsNoSwap.accountCode, //assetTransferCaptureDisplayState.assetTransferEntry.custRefNum,
            "category": assetTransferCaptureDisplayState.assetTransferEntry.category,
            "instructionType": assetTransferCaptureDisplayState.assetTransferEntry.instructionType,
            "accountType": assetTransferCaptureDisplayState.assetTransferEntry.accountType,
            "srcSecCd": assetTransferCaptureDisplayState.assetTransferEntry.srcSecCd,
            "tradeDate": assetTransferCaptureDisplayState.assetTransferEntry.tradeDate ? assetTransferCaptureDisplayState.assetTransferEntry.tradeDate.replaceAll("-", "") : assetTransferCaptureDisplayState.assetTransferEntry.tradeDate,
            "settleDate": assetTransferCaptureDisplayState.assetTransferEntry.settleDate ? assetTransferCaptureDisplayState.assetTransferEntry.settleDate.replaceAll("-", "") : assetTransferCaptureDisplayState.assetTransferEntry.settleDate,
            "settleLocation": assetTransferCaptureDisplayState.assetTransferEntry.settleLocation,
            "settleCurrency": assetTransferCaptureDisplayState.assetTransferEntry.settleCurrency,
            "settleQuantity": assetTransferCaptureDisplayState.assetTransferEntry.settleQuantity ? assetTransferCaptureDisplayState.assetTransferEntry.settleQuantity.toString().replaceAll(",", "") : assetTransferCaptureDisplayState.assetTransferEntry.settleQuantity,
            "settleAmount": assetTransferCaptureDisplayState.assetTransferEntry.settleAmount ? assetTransferCaptureDisplayState.assetTransferEntry.settleAmount.toString().replaceAll(",", "") : '0.00',
            "additionalInfo": assetTransferCaptureDisplayState.assetTransferEntry.additionalInfo,
            "comment": '',
            "manager": managerNameUsed
        }
        params = addParamsOnCategory(assetTransferCaptureDisplayState, params)


        if (VALIDATION_IN_JS) {
            formErrors = validateAmendForm(params);
        }
        if (Object.keys(formErrors).length > 0) {
            setErrors(formErrors)
            return
        }
        else {

            const onSuccessResponse = (res) => {
                if (res.data) {
                    setAmendClicked(true);

                    let assetTransferCaptureDisplayStateChange = { ...assetTransferCaptureDisplayState }
                    assetTransferCaptureDisplayStateChange['assetTransferEntry']['resData'] = res.data
                    if (res?.data?.requestId) {
                        assetTransferCaptureDisplayStateChange['assetTransferEntry']['requestId'] = res.data.requestId
                    }
                    if (res?.data?.status) {
                        assetTransferCaptureDisplayStateChange['assetTransferEntry']['status'] = res.data.status
                    }
                    assetTransferCaptureDisplayStateChange['assetTransferEntry']['from'] = ''

                    assetTransferCaptureDisplayStateChange.currentPage = ASSET_TRANSFER_CAPTURE_PANEL_ENTRY_RESULT
                    setAssetTransferCaptureDisplayState(assetTransferCaptureDisplayStateChange);
                }
            }

            const onErrorResponse = (err) => {
                let errorMsg = getAllErrorValuesAsString(err.response.data)
                console.error("Error on amend Asset Transfer:", errorMsg)
                error("Error on amend Asset Transfer")
            }

            makePostRequest(params, URL.ASSET_TRANSFER_AMEND_URL, onSuccessResponse, onErrorResponse)
        }
    }

    const handleCancel = (e) => {

        e.preventDefault()
        let formErrors = {}

        let managerNameUsed = ""
        if (assetTransferCaptureDisplayState.assetTransferEntry.manager) {
            managerNameUsed = assetTransferCaptureDisplayState.assetTransferEntry.manager
        } else {
            // new, need get from entityAccounts select component
            managerNameUsed = (entityAccountsNoSwap.managerName != null && entityAccountsNoSwap.managerName.indexOf("-") >= 0) ? entityAccountsNoSwap.managerName.substring(0, entityAccountsNoSwap.managerName.indexOf("-")) : entityAccountsNoSwap.managerName
        }
        const params =
            [{
                "requestId": assetTransferCaptureDisplayState.assetTransferEntry.requestId,
                "cdUser": "",
                "manager": managerNameUsed,
                "cdAccount": entityAccountsNoSwap.accountCode, //assetTransferCaptureDisplayState.assetTransferEntry.custRefNum
            }]

        if (VALIDATION_IN_JS) {
            formErrors = validateCancelForm(params);
        }
        if (Object.keys(formErrors).length > 0) {
            setErrors(formErrors)
            return
        }
        else {

            const onSuccessResponse = (res) => {
                if (res.data) {
                    let assetTransferCaptureDisplayStateChange = { ...assetTransferCaptureDisplayState }
                    assetTransferCaptureDisplayStateChange['assetTransferEntry']['resData'] = res.data
                    if (res?.data?.requestId) {
                        assetTransferCaptureDisplayStateChange['assetTransferEntry']['requestId'] = res.data.requestId
                    }
                    if (res?.data?.status) {
                        assetTransferCaptureDisplayStateChange['assetTransferEntry']['status'] = res.data.status
                    }
                    assetTransferCaptureDisplayStateChange['assetTransferEntry']['from'] = ''

                    assetTransferCaptureDisplayStateChange.currentPage = ASSET_TRANSFER_CAPTURE_PANEL_ENTRY_RESULT
                    setAssetTransferCaptureDisplayState(assetTransferCaptureDisplayStateChange);
                }
            }

            const onErrorResponse = (err) => {
                let errorMsg = getAllErrorValuesAsString(err.response.data)
                console.error("Error on cancel Asset Transfer:", errorMsg)
                error("Error on cancel Asset Transfer")
            }

            makePostRequest(params, URL.ASSET_TRANSFER_CANCEL_URL, onSuccessResponse, onErrorResponse)
        }
    }


    const header = function () {
        //Need to investigate why this is called multiple times
        const status = !assetTransferCaptureDisplayState.assetTransferEntry.uiStatus ? '' : assetTransferCaptureDisplayState.assetTransferEntry.uiStatus;
        return (
            <>
                <Container fluid>
                    <Row>
                        <Col className="px-md-3">
                            <h1>Asset Transfer Status: {status}</h1>
                        </Col>

                    </Row>

                </Container>
            </>
        );
    }

    const controlButtons = function () {
        //Need to investigate why this is called multiple times

        if (id === "" || id === undefined || id === null) {
            return (
                <Row className="py-3">
                    <Col lg={8} className="d-none d-md-block"></Col>
                    <Col xs={6} sm={6} md={2} className="pt-2">
                        <button className="btn btn-block td-btn-secondary-clear" href="#" onClick={(event) => {
                            handleOnClear(event)
                        }}>Clear
                        </button>
                    </Col>

                    <Col xs={6} sm={6} md={2} className="pt-2">
                        <button className="btn btn-block td-btn-primary-light" disabled={disableSubmit} type={'submit'}
                            onClick={handleSubmit}>Submit
                        </button>
                    </Col>
                </Row>
            );
        }
        else if (id === 'SUBMITTED' || id === 'ERROR' || id === 'ERROR - TD TO AMEND') {
            return (
                <Row className="py-3">
                    <Col md={6} className="d-none d-md-block"></Col>
                    <Col xs={4} sm={4} md={2} className="pt-2">
                        <button className="btn btn-block td-btn-secondary-clear" onClick={() => handleBack()}>Back
                        </button>
                    </Col>
 
                    <Col xs={4} sm={4} md={2} className="pt-2">
                        <button disabled={disableSubmit} disabled={disableSubmit} className="btn btn-block td-btn-CTA"
                            onClick={handleCancel}>Cancel
                        </button>
                    </Col>

                    <Col xs={4} sm={4} md={2} className="pt-2">
                        <button disabled={disableSubmit} disabled={disableSubmit} className="btn btn-block td-btn-primary-light" type={'submit'}
                            onClick={handleAmend}>Amend
                        </button>
                    </Col>
                </Row>
            );
        }
        else {
            return (
                <Form onSubmit={(e) => e.preventDefault()}>
                    <Row className="py-3">
                        <Col lg={10} className="d-none d-md-block"></Col>
                        <Col xs={12} sm={12} md={2} className="pt-2">
                            <button className="btn btn-block td-btn-secondary-clear" onClick={() => handleBack()}>Back
                            </button>
                        </Col>
                    </Row>
                </Form>
            );
        }
    }



    return (<>

        <Container fluid>
            <Row className="justify-content-start navbar td-" style={{ paddingTop: 20, paddingBottom: 10 }}>
                <Col style={{ paddingLeft: 0 }} xs={"auto"}>
                    {header()}
                </Col>
            </Row>


            <Row>
                <Col>
                    <Form onSubmit={(e) => e.preventDefault()}>
                        <Form.Row>
                            <AssetTransferEntityAccountsPart entityReadOnly={viewClicked && !fromMenu} />
                            <Col xs={12} sm={4} md={4} xl={4} lg={4} className="pt-0">


                                <Form.Group controlId="formGridCategory" className={'td-select'}>
                                    <Form.Label className="filter-input-label">Asset Transfer Type <span className='red-cell'>*</span></Form.Label>
                                    <Form.Control disabled={viewClicked && !fromMenu} as="select" name={"category"} value={assetTransferCaptureDisplayState.assetTransferEntry.category} onChange={handleOnChange}>
                                        {
                                            assetTransferTypeJSON.map(item =>
                                                <option key={item['id']} value={item['id']}>{item['name']}</option>
                                            )
                                        }
                                    </Form.Control>
                                </Form.Group>
                            </Col>
                        </Form.Row>
                        <Form.Row>
                            <Col xs={12} sm={12} md={12} xl={12} lg={12} className="pt-0">
                                <hr className="td-thin-divider-line-2 pt-3"></hr>
                            </Col>
                            <Col xs={0} sm={1} md={1} xl={1} lg={1} className="pt-0"></Col>
                        </Form.Row>
                        <Form.Row>
                            {/*
                            <Col xs={6} sm={4} md={4} xl={4} lg={4} className="pt-0">
                                <Form.Group controlId="formGridCustRefNum">
                                    <Form.Label ref={target}>Customer Reference Number {custRefNumS  && <span className='red-cell'>*</span>}</Form.Label>
                                    <Form.Control disabled={isDisabled} placeholder="" name={"custRefNum"} value={assetTransferCaptureDisplayState.assetTransferEntry.custRefNum}
                                                  onChange={handleOnChange}
                                                  isInvalid={!!errors.custRefNum}
                                    />
                                    <Form.Control.Feedback type={"invalid"}><b><i className="bi bi-exclamation-circle"></i>{errors.custRefNum}</b></Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                            */}
                            <Col xs={12} sm={4} md={4} xl={2} lg={4} className="pt-0">
                                <Form.Group controlId="formGridAccountType" className={'td-select'}>
                                    <Form.Label>Long/Short/Cash {accountTypeS  && <span className='red-cell'>*</span>}</Form.Label>
                                    <OverlayTrigger
                                        placement="top"
                                        overlay={
                                            <Tooltip id="tooltip-accountType">
                                                {assetTransferCaptureDisplayState.assetTransferEntry.accountType ? assetTransferCaptureDisplayState.assetTransferEntry.accountType : "Select"}
                                            </Tooltip>
                                        }
                                    >
                                    <Form.Control disabled={isDisabled} as="select" name={"accountType"} value={assetTransferCaptureDisplayState.assetTransferEntry.accountType} onChange={handleOnChange} isInvalid={!!errors.accountType}
                                                  style={![...accountTypeList,''].includes(assetTransferCaptureDisplayState.assetTransferEntry.accountType) ? { backgroundColor: '#F7E8E9', color: '#AE1100' } : {}}>
                                        {
                                            accountTypeJSON.map(item =>
                                                <option key={item['id']} value={item['id']}>{item['name']}</option>
                                            )
                                        }
                                    </Form.Control>
                                    </OverlayTrigger>
                                    <Form.Control.Feedback type={"invalid"}><b><i className="bi bi-exclamation-circle"></i>{errors.accountType}</b></Form.Control.Feedback>
                                </Form.Group>


                            </Col>
                            <Col xs={12} sm={4} md={4} xl={2} lg={4} className="pt-0">
                                <Form.Group controlId="formGridInstructionType" className={'td-select'}>
                                    <Form.Label>Instruction Type {instructionTypeS  && <span className='red-cell'>*</span>}</Form.Label>
                                    <OverlayTrigger
                                        placement="top"
                                        overlay={
                                            <Tooltip id="tooltip-instructionType">
                                                {assetTransferCaptureDisplayState.assetTransferEntry.instructionType ? assetTransferCaptureDisplayState.assetTransferEntry.instructionType : "Select"}
                                            </Tooltip>
                                        }
                                    >
                                    <Form.Control disabled={isDisabled} as="select" name={"instructionType"} value={assetTransferCaptureDisplayState.assetTransferEntry.instructionType} onChange={handleOnChange} isInvalid={!!errors.instructionType}
                                                  style={![...instructionTypeList,''].includes(assetTransferCaptureDisplayState.assetTransferEntry.instructionType) ? { backgroundColor: '#F7E8E9', color: '#AE1100' } : {}}
                                    >{
                                        instructionTypeJSON.map(inst => <option key={inst.id} value={inst.id}>{inst.name}</option>)}
                                    </Form.Control>
                                    </OverlayTrigger>
                                    <Form.Control.Feedback type={"invalid"}><b><i className="bi bi-exclamation-circle"></i>{errors.instructionType}</b></Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                           {  assetTransferCaptureDisplayState.assetTransferEntry.category && assetTransferCaptureDisplayState.assetTransferEntry.category === 'INTL' && (
                            <>                            
                            <Col xs={12} sm={4} md={4} xl={2} lg={4} className="pt-0">
                                <Form.Group controlId="formGridBrokerMpidId" className={'td-select'}>
                                    <Form.Label>Broker MPID {brokerMpidIdS  && <span className='red-cell'>*</span>}</Form.Label>
                                    <OverlayTrigger
                                        placement="top"
                                        overlay={
                                            <Tooltip id="tooltip-brokerMpidId">
                                                {assetTransferCaptureDisplayState.assetTransferEntry.brokerMpidId ? assetTransferCaptureDisplayState.assetTransferEntry.brokerMpidId : "Select"}
                                            </Tooltip>
                                        }
                                    >
                                    <Form.Control disabled={brokerMpidIdReadOnly} as="select" name={"brokerMpidId"} value={assetTransferCaptureDisplayState.assetTransferEntry.brokerMpidId} onChange={handleOnChange} isInvalid={!!errors.brokerMpidId}
                                                  style={![...mpids.map(inst =>inst.brokerMpid),''].includes(assetTransferCaptureDisplayState.assetTransferEntry.brokerMpidId) ? { backgroundColor: '#F7E8E9', color: '#AE1100' } : {}}
                                    >
                                         <option key='' value=''>Select</option>
                                        { mpids.map(inst => <option key={inst.brokerMpid} value={inst.brokerMpid}>{inst.brokerName + '-' + inst.brokerMpid}</option>)}
                                    </Form.Control>
                                    </OverlayTrigger>
                                    <Form.Control.Feedback type={"invalid"}><b><i className="bi bi-exclamation-circle"></i>{errors.brokerMpidId}</b></Form.Control.Feedback>
                                </Form.Group>
                            </Col>

                            <Col xs={12} sm={4} md={4} xl={2} lg={4} className="pt-0">
                            <Form.Group controlId="formGridCptyAccountNumber">
                                <Form.Label ref={target}>CPTY Account Number {cptyAccountNumberS && <span className='red-cell'>*</span>}</Form.Label>
                                <Form.Control disabled={cptyAccountNumberReadOnly} placeholder="" name={"cptyAccountNumber"} value={assetTransferCaptureDisplayState.assetTransferEntry.cptyAccountNumber}
                                    onChange={handleOnChange}
                                    maxLength={20}
                                    isInvalid={!!errors.cptyAccountNumber}
                                />
                                <Form.Control.Feedback type={"invalid"}><b><i className="bi bi-exclamation-circle"></i>{errors.cptyAccountNumber}</b></Form.Control.Feedback>
                            </Form.Group>
                            </Col>
                            </>
                              )
                             }

                            <Col xs={12} sm={4} md={4} xl={2} lg={4} className="pt-0">
                                <Form.Group controlId="formGridSrcSecCd">
                                    <Form.Label ref={target}>Security Id {srcSecCdS && <span className='red-cell'>*</span>}</Form.Label>
                                    <Form.Control disabled={isDisabled} placeholder="ABCD" name={"srcSecCd"} value={assetTransferCaptureDisplayState.assetTransferEntry.srcSecCd}
                                        onChange={handleOnChange}
                                        onBlur={handleSecurityOnBlur}
                                        isInvalid={!!errors.srcSecCd}
                                    />
                                    <Form.Control.Feedback type={"invalid"}><b><i className="bi bi-exclamation-circle"></i>{errors.srcSecCd}</b></Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                            <Col xs={12} sm={4} md={4} lg={4} xl={2} className="pt-0">
                                <Form.Group controlId="formGridTradeDate">
                                    <Form.Label ref={assetTransferDateLabelRef}>Trade Date {tradeDateS && <span className='red-cell'>*</span>}</Form.Label>
                                    <Form.Control disabled={isDisabled} type="date" name={"tradeDate"} value={assetTransferCaptureDisplayState.assetTransferEntry.tradeDate} onChange={handleOnChange}
                                        onBlur={handleTradeDateBlur} isInvalid={!!errors.tradeDate}
                                        min={getCurrentDateToDatePickerFormat()} max={getMaxYear4DigitsFormat()} />
                                    <Form.Control.Feedback type={"invalid"}><b><i className="bi bi-exclamation-circle"></i>{errors.tradeDate}</b></Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                            <Col xs={12} sm={4} md={4} lg={4} xl={2} className="pt-0">
                                <Form.Group controlId="formGridSettleDate">
                                    <Form.Label ref={settleDateLabelRef}>Settlement Date {settleDateS && <span className='red-cell'>*</span>}</Form.Label>
                                    <Form.Control disabled={isDisabled} type="date" name={"settleDate"} value={assetTransferCaptureDisplayState.assetTransferEntry.settleDate} onChange={handleOnChange}
                                        isInvalid={!!errors.settleDate}
                                        min={getCurrentDateToDatePickerFormat()} max={getMaxYear4DigitsFormat()} />
                                    <Form.Control.Feedback type={"invalid"}><b><i className="bi bi-exclamation-circle"></i>{errors.settleDate}</b></Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                            <Col xs={6} sm={4} md={4} lg={2} xl={2} className="pt-0">
                                <Form.Group controlId="formGridSettleLocation"  className={'td-select'}>
                                    <Form.Label>Settlement Location {settleLocationS && <span className='red-cell'>*</span>}</Form.Label>
                                    <Form.Control disabled={settleReadOnly} as="select" name={"settleLocation"} value={assetTransferCaptureDisplayState.assetTransferEntry.settleLocation} onChange={handleOnChange}>
                                        {
                                            countries.map(item =>
                                                <option key={item['countryCode']} value={item['countryCode']}>{item['countryCode']}</option>
                                            )
                                        }
                                    </Form.Control>
                                    <Form.Control.Feedback type={"invalid"} style={{ display: !!errors.settleLocation ? 'block' : 'none' }}><b><i className="bi bi-exclamation-circle"></i>{errors.settleLocation}</b></Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                            <Col xs={6} sm={4} md={4} xl={2} lg={2} className="pt-0">
                                <Form.Group controlId="formGridSettleCurrency" className={'td-select'}>
                                    <Form.Label>Settlement Currency {settleCurrencyS && <span className='red-cell'>*</span>}</Form.Label>
                                    <Form.Control disabled={settleReadOnly} as="select" name={"settleCurrency"} value={assetTransferCaptureDisplayState.assetTransferEntry.settleCurrency} onChange={handleOnChange}>
                                        {
                                            currencies.map(item =>
                                                <option key={item['isoCurrencyCode']} value={item['isoCurrencyCode']}>{item['isoCurrencyCode']}</option>
                                            )
                                        }
                                    </Form.Control>
                                    <Form.Control.Feedback type={"invalid"} style={{ display: !!errors.settleCurrency ? 'block' : 'none' }}><b><i className="bi bi-exclamation-circle"></i>{errors.settleCurrency}</b></Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                            <Col xs={12} sm={4} md={4} xl={2} lg={2} className="pt-0">
                                <Form.Group controlId="formGridSettleQuantity" className="pt-0">
                                    <Form.Label ref={quantityLabelRef}>Settlement Quantity {settleQuantityS && <span className='red-cell'>*</span>}</Form.Label>
                                    <NumberFormat
                                        disabled={isDisabled} value={assetTransferCaptureDisplayState.assetTransferEntry.settleQuantity}
                                        isAllowed={(values) => {
                                            const { value } = values;
                                            return value || value ==='';
                                        }}
                                        allowNegative={false}
                                        thousandSeparator={true}      // Add commas as thousand separators
                                        decimalScale={0}              // Two decimal places for price
                                        fixedDecimalScale={true}       // Always show two decimal places
                                        name="settleQuantity"                  // Set the name to "price"
                                        id="settleQuantity"
                                        onValueChange={({ formattedValue, value, floatValue }) =>
                                            handleOnChangeNumber({ formattedValue, value, floatValue }, 'settleQuantity')
                                        }
                                        className={!!errors.settleQuantity ? "form-control is-invalid" : "form-control"}
                                    />

                                    <Form.Control.Feedback type={"invalid"} style={{ display: !!errors.settleQuantity ? 'block' : 'none' }}><b><i className="bi bi-exclamation-circle"></i>{errors.settleQuantity}</b></Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                            <Col xs={6} sm={4} md={4} xl={2} lg={2} className="pt-0">
                                <Form.Group controlId="formGridSettleAmount">
                                    <Form.Label ref={settleAmountLabelRef}>Settlement Amount {settleAmountS && <span className='red-cell'>*</span>}</Form.Label>
                                    <NumberFormat
                                        disabled={isDisabled || settleAmountDisabled} value={assetTransferCaptureDisplayState.assetTransferEntry.settleAmount}
                                        isAllowed={(values) => {
                                            const { value } = values;
                                            return value;
                                        }}
                                        allowNegative={false}
                                        thousandSeparator={true}      // Add commas as thousand separators
                                        decimalScale={2}              // Two decimal places for price
                                        fixedDecimalScale={true}       // Always show two decimal places
                                        name="settleAmount"                  // Set the name to "settleAmount"
                                        id="settleAmount"
                                        onValueChange={({ formattedValue, value, floatValue }) =>
                                            handleOnChangeNumber({ formattedValue, value, floatValue }, 'settleAmount')
                                        }
                                        allowEmptyFormatting className={!!errors.settleAmount ? "form-control is-invalid" : "form-control"}
                                    />
                                    <Form.Control.Feedback type={"invalid"} style={{ display: !!errors.settleAmount ? 'block' : 'none' }}><b><i className="bi bi-exclamation-circle"></i>{errors.settleAmount}</b></Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                            <Col xs={6} sm={4} md={4} lg={2} xl={2} className="pt-0">
                                <Form.Group controlId="formGridDtcNumber">
                                    <Form.Label>DTC number {dtcNumberS && <span className='red-cell'>*</span>}</Form.Label>
                                    <Form.Control disabled={dtcNumberReadOnly} placeholder="" name={"dtcNumber"} value={assetTransferCaptureDisplayState.assetTransferEntry.dtcNumber} onChange={handleOnChange}
                                        isInvalid={!!errors.dtcNumber} />
                                    <Form.Control.Feedback type={"invalid"}><b><i className="bi bi-exclamation-circle"></i>{errors.dtcNumber}</b></Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                            <Col xs={6} sm={4} md={4} lg={2} xl={2} className="pt-0">
                                <Form.Group controlId="formGridDtcAcctNumber">
                                    <Form.Label>DTC account number {dtcAcctNumberS && <span className='red-cell'>*</span>}</Form.Label>
                                    <Form.Control disabled={dtcAcctNumberReadOnly} placeholder="" name={"dtcAcctNumber"} value={assetTransferCaptureDisplayState.assetTransferEntry.dtcAcctNumber} onChange={handleOnChange}
                                        isInvalid={!!errors.dtcAcctNumber} />
                                    <Form.Control.Feedback type={"invalid"}><b><i className="bi bi-exclamation-circle"></i>{errors.dtcAcctNumber}</b></Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                            <Col xs={6} sm={4} md={4} lg={2} xl={2} className="pt-0">
                                <Form.Group controlId="formGridFedInstruction">
                                    <Form.Label>FED Delivery Instruction {fedInstructionS && <span className='red-cell'>*</span>}</Form.Label>
                                    <Form.Control disabled={fedInstructionReadOnly} placeholder="" name={"fedInstruction"} value={assetTransferCaptureDisplayState.assetTransferEntry.fedInstruction} onChange={handleOnChange}
                                        isInvalid={!!errors.fedInstruction} />
                                    <Form.Control.Feedback type={"invalid"}><b><i className="bi bi-exclamation-circle"></i>{errors.fedInstruction}</b></Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                            <Col xs={6} sm={6} md={6} lg={3} xl={3} className="pt-0">
                                <Form.Group controlId="formGridAdditionalInfo">
                                    <Form.Label>Additional Information {additionalInfoS && <span className='red-cell'>*</span>}</Form.Label>
                                    <Form.Control disabled={isDisabled} placeholder="" name={"additionalInfo"} value={assetTransferCaptureDisplayState.assetTransferEntry.additionalInfo} onChange={handleOnChange}
                                        isInvalid={!!errors.additionalInfo} />
                                    <Form.Control.Feedback type={"invalid"}><b><i className="bi bi-exclamation-circle"></i>{errors.additionalInfo}</b></Form.Control.Feedback>
                                </Form.Group>
                            </Col>

                            {(viewClicked && !fromMenu) &&
                                <Col xs={6} sm={5} md={5} lg={5} xl={4} className="pt-0">
                                    <Form.Group controlId="formGridComment">
                                        <Form.Label>Comments {commentsS && <span className='red-cell'>*</span>}</Form.Label>
                                        <OverlayTrigger
                                            placement="top"
                                            overlay={
                                                <Tooltip id="tooltip-comment">
                                                    {assetTransferCaptureDisplayState.assetTransferEntry.comment ? assetTransferCaptureDisplayState.assetTransferEntry.comment : "Comments is readonly"}
                                                </Tooltip>
                                            }
                                        >
                                            <Form.Control
                                                disabled={true}
                                                placeholder=""
                                                name={"comment"}
                                                value={assetTransferCaptureDisplayState.assetTransferEntry.comment}
                                                onChange={handleOnChange}
                                                style={assetTransferCaptureDisplayState.assetTransferEntry.comment ? { backgroundColor: '#F7E8E9', color: '#AE1100' } : {}}
                                                isInvalid={!!errors.comment}
                                            />
                                        </OverlayTrigger>
                                        <Form.Control.Feedback type={"invalid"}>
                                            <b><i className="bi bi-exclamation-circle"></i>{errors.comment}</b>
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </Col>
                            }
                        </Form.Row>
                    </Form>
                </Col>
            </Row>

            {controlButtons()}
        </Container>

    </>);

}